export default {
  merchantsTypeCodeResults(currentState, value) {
    const state = currentState;
    state.merchantsTypeCodeResults = Object.assign([], value);
  },
};
